import React from 'react';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { TOMOS, TOMO_INCLUDES } from '../../data/content';
export function TomosList() {
  return <section className="relative w-full bg-ink px-5 py-12 sm:py-16" data-id="element-229" data-mp="1rc4xo0eg4ya9">
      <div className="mx-auto max-w-3xl" data-id="element-230" data-mp="1vcf2vauezko2">
        <h2 className="text-center font-display text-3xl text-white sm:text-5xl" data-id="element-231" data-mp="20b0154q3vu9v">📚 6 Tomos Completos</h2>

        <div className="mt-7 space-y-2.5" data-id="element-232" data-mp="13kzjrqs2gg2l">
          {TOMOS.map((tomo, index) => <details key={tomo.n} open={index === 0} className="group rounded-xl border border-ink-border bg-ink-card" data-id="element-233" data-mp="17mayh19ejgw0" data-mpi={index}>
              <summary className="flex cursor-pointer list-none items-center gap-3 p-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-aqua sm:p-4 [&::-webkit-details-marker]:hidden" data-id="element-234" data-mp="1ck2yyjo44bbt">
                <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg font-display text-lg text-ink" style={{
              backgroundColor: tomo.color
            }} data-id="element-235" data-mp="ovjt0asjcamw">
                  {tomo.n}
                </span>
                <span className="flex-1" data-id="element-236" data-mp="2los32p3h3ivv">
                  <span className="block text-[10px] font-bold uppercase tracking-widest text-white/40" data-id="element-237" data-mp="2gv5q0vtedczj">Tomo {tomo.n}</span>
                  <span className="block text-sm font-bold leading-snug text-white sm:text-base" data-id="element-238" data-mp="2bw2wa7ivat6v">{tomo.title}</span>
                </span>
                <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-white/50 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" data-id="element-239" data-mp="26vevwv8r0zzz" />
              </summary>
              <p className="px-3.5 pb-3.5 text-sm leading-relaxed text-white/70 sm:px-4 sm:pb-4" data-id="element-240" data-mp="1syjmv2shz8jx">{tomo.desc}</p>
            </details>)}
        </div>

        <div className="mt-7 rounded-xl border border-lime/30 bg-lime/5 p-5 sm:p-6" data-id="element-241" data-mp="3s91dcruggs1u">
          <h3 className="font-display text-xl text-lime" data-id="element-242" data-mp="3ncsscxtku4mr">Cada tomo incluye:</h3>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-243" data-mp="aagoyhykmfxu">
            {TOMO_INCLUDES.map(item => <li key={item} className="flex items-start gap-2" data-id="element-244" data-mp="f3jk2uizxxg5">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-245" data-mp="1b3lc5x4oll1" />
                <span className="text-sm text-white/85" data-id="element-246" data-mp="6952umewocue">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}